import { cn } from '@/lib/utils';

interface AWSLambdaIconProps {
  className?: string;
}

export function AWSLambdaIcon({ className }: AWSLambdaIconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      className={cn('text-[#FF9900]', className)}
      aria-hidden="true"
    >
      <path d="M4.98 21.49H.94l6.81-14.98 2.01 4zM12.44 21.49h-3.97l5.19-11.87 1.99 3.98zM23.09 21.49h-4.15l-6.05-13.92-.01-.01-2.88-4.97h4.09l9.03 18.9zM14.64.81H8.85L1.17 18.06v2.83h2.14l7.87-17.37 3.46 7.94 2.48 5.7 2.21 4.33h3.73v-2.82z" />
    </svg>
  );
}
